<ng-template #CancelEcAgreement>
    <div class="centered-content">
        <div
            style="display: flex; justify-content: center; align-items: center; flex-direction: column; background: #e6e6e6">
            <div
                style="max-width: 736px; width: 100%; height: auto; margin: 0 auto; padding: 20px 44px 40px; background: #fff">
                <div nxLayout="grid maxwidth">
                    <div nxRow>
                        <div nxCol="12" style="text-align: center;">
                            <h3 nxHeadline="subsection-medium" translate>
                                profile.texts.cancel-ec-agreement</h3>
                            <p translate>
                                profile.texts.cancel-ec-agreement-info
                            </p>
                        </div>
                    </div>
                    <div nxRow class="nx-margin-bottom-s cancel-ec-agreement__checklist">
                        <div nxCol="12">
                            <cpc-icon icon='close' color='#cc3914' style="font-size: 24px">
                            </cpc-icon>
                            <div translate>profile.texts.cancel-ec-agreement-info-2</div>
                        </div>
                    </div>
                    <div nxRow class="nx-margin-bottom-s cancel-ec-agreement__checklist">
                        <div nxCol="12" translate>
                            <cpc-icon icon='close' color='#cc3914' style="font-size: 24px">
                            </cpc-icon>
                            <div translate>profile.texts.cancel-ec-agreement-info-3</div>
                        </div>
                    </div>
                    <div nxRow class="nx-margin-bottom-s">
                        <div nxCol="12" style="text-align: center;" translate>
                            profile.texts.cancel-ec-agreement-info-4
                        </div>
                    </div>
                    <div nxRow rowJustify="around">
                        <button nxButton="secondary normal" type="button" (click)="closeModal()"><span
                                translate>common.no</span></button>
                        <button nxButton="primary normal" type="button" (click)="cancelEcAgreement()"><span
                                translate>common.yes</span></button>
                    </div>
                </div>
            </div>
        </div>
    </div>

</ng-template>